<template>
 <!-- 添加子账号  -->
  <div class="dialogBox" >
    <el-dialog title="Share order"   :visible.sync="showDialog" @close="clkCloseBtn" :close-on-click-modal="false" custom-class="borRad10" width="460px">
      <el-form :model="share" :rules="rules" ref="share"  class="shareFrom font12">
        <div class="clear" style="text-align:center">
          <div class="lLabel"></div>
          <div class="rInput">
            The shared person can only see other information except fees,and 
            <span class="preview" @click="showPre">click the preview page</span>  
          </div>
        </div>
        <div class="clear">
          <div class="lLabel">Order No.：</div>
          <div class="rInput">{{Id}}</div>
        </div>
        <div class="clear">
          <div class="lLabel" style="height: 30px;line-height: 30px;">Shared email：</div>
          <div class="rInput">
            <el-form-item label="" prop="Email" label-width="0" >
              <el-input class="rInput" v-model="share.Email" ></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="clear">
          <div class="lLabel">Note：</div>
          <div class="rInput">
            <el-form-item label="" prop="Note" label-width="0" >
              <el-input type="textarea"   v-model="share.Note" ></el-input>
            </el-form-item>
          </div>
        </div>
        <el-form-item>
          <div style="text-align:center;" >
            <a class="blueBtn30" @click="submitForm('share')">SUMBIT</a>
          </div>
        </el-form-item>
      </el-form>    
    </el-dialog>
    <preview ref="preview"></preview>
  </div>
      
</template>
<script>
import { post, fetch } from "@/ask/axios";
import bus from '@/ask/eventBus'
import { elAlert } from '@/utils/bulletBox'
import preview from "@/components/userCenter/public/preview";
export default {
  components: {preview},
  data() {
    return {
      showDialog:false,
      Id:'',
      share:{
        Email:'',
        Note:'',
        EmailHolder:'Please enter you Email',
        NoteHolder:'Please enter you Note',
      },
      rules: {
        Email: [
          { required: true, message: 'Required', trigger: 'blur' },
          { min: 1, max: 50, message: 'Maximum is 50 characters' },
          {
            pattern: /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,  //正则
            message: 'Please enter a valid email address'
          }
        ],
        Note: [
          { required: true, message: 'Required', trigger: 'blur' },
          { min: 1, max:500, message: 'Maximum is 500 characters'}
        ],
      }
    }
  },
  mounted() {

  },
  
  methods:{
    //显示弹窗  传入订单号
    clkDialog(Id){
      this.Id = Id
      this.showDialog=true
    },
    //关闭弹窗
    clkCloseBtn(){
      this.showDialog=false
    },
    //调用新增接口
    shareApi() {
        let param={
          Remark: this.share.Note,
          WaybillNO: this.Id,
          Emails: [{"Email": this.share.Email}]
        }
        let url=this.$api03+"/api/TradeCustomer/Email/ShareOrder";
        if(this.$route.path === '/air/airDetails') {
          url=this.$api03+"/api/TradeCustomer/Email/ShareAirOrder";
        }
        post(url,param).then( (res)=> {
          if(res.Results){
            elAlert(this,"success").then(()=>{
              this.clkCloseBtn()
            }).catch(()=>{
              this.clkCloseBtn()
            })
          }
        })
    },
    // 校验
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.shareApi()
        } else {
          return false;
        }
      });
    },
    // 展示页面弹框
    showPre() {
      this.$refs.preview.clkDialog()
    }
  }
}
</script>
<style>
.shareFrom .el-form-item.is-success .el-input__inner, .el-form-item.is-success .el-input__inner:focus, .el-form-item.is-success .el-textarea__inner, .el-form-item.is-success .el-textarea__inner:focus{border-color: #DCDFE6 !important;}
.shareFrom .el-form-item__error {margin-top:0px}
.shareFrom .el-textarea__inner {font-size: 12px !important;font-family: auto;}
.shareFrom .el-form-item__content {line-height: 30px;}
.shareFrom .el-form-item {margin-bottom:10px}
.shareFrom .el-form-item__label{font-size: 12px !important;}
.shareFrom .el-form-item .el-input__inner{font-size: 12px;}
.shareFrom .el-form-item .el-form-item__error{color: red!important}
.shareFrom .el-form-item.is-error .el-input__inner{border-color: red!important}
.shareFrom .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before{color: red!important}


</style>
<style scoped>
.blueBtn30{display: inline-block; width: 136px;font-size: 12px; height: 34px;line-height: 34px;text-align: center;    border: 1px solid #004FB1;border-radius: 30px;background-color: #004FB1;color: #fff !important;}
.shareFrom .clear{margin-bottom: 10px;min-height: 10px; }
.rInput{width:200px;font-size:12px}
.share-li{line-height:1.5;height: 40px;}
.lLabel{color: black; min-height: 20px; width: 115px;text-align: right;padding-right:12px ;box-sizing: border-box;float: left;}
.rInput{float: left;color: black;width: 300px; font-size: 12px; text-align: left; line-height: 1.5;}
.left115{width: 115px;text-align: right;padding-right:12px ;box-sizing: border-box;}
.preview{text-decoration: underline;cursor: pointer;color: #004FB1;}

</style>


// WEBPACK FOOTER //
// src/components/userCenter/public/shareOrder.vue